/**
 * MemoryTab
 * Combines the agent's memory *policy* (editable) with the full memory
 * *browser* in a single unified tab, replacing the old split "Memory" +
 * "Data" tabs.
 */

import React from 'react';
import { Stack } from '@mui/material';

import type { AgentDetail as AgentDetailType } from '../../../types';
import { MemoryPolicyPanel } from './MemoryPolicyPanel';
import { AgentMemoryBrowser } from '../AgentMemoryBrowser';

interface MemoryTabProps {
  agent: AgentDetailType;
  onEditPolicy: () => void;
}

export const MemoryTab: React.FC<MemoryTabProps> = ({ agent, onEditPolicy }) => (
  <Stack spacing={{ xs: 2, sm: 2.5 }}>
    <MemoryPolicyPanel agent={agent} onEdit={onEditPolicy} />
    <AgentMemoryBrowser agentId={agent.id} />
  </Stack>
);

export default MemoryTab;
